<template functional>
  <div class="flex align-center cursor-pointer group"
       :class="[data.staticClass,data.class] || ''"
       v-on="listeners">
    <div class="text-icon w-6 h-6 mr-3">
      <slot name="icon"></slot>
    </div>
    <div class="text-sm text-text group-hover:text-red
                  border-b border-dashed border-icon group-hover:border-red
                  transition duration-200">
      {{ props.text }}
    </div>
  </div>

</template>

<script>
export default {
  name: "LinkWIcon"
}
</script>